<template>
  <li>
    <span class="setting-title">
      <a
        :href="getUrl(setting)"
        target="_blank"
      >{{ settingTitle(setting) }}</a>
    </span>
    <span class="setting-actions">
      <i
        class="trash fas fa-trash"
        @click="removeSetting(setting)"
      />
      <span :class="['hint-copy', {'active': copyHint}]">Copied</span>
      <i
        class="far fa-copy"
        @click="copy(setting)"
      />
      <a
        :href="getUrl(setting)"
        target="_blank"
        class="external fas fa-external-link-alt"
      />
    </span>
  </li>
</template>

<script>
export default {
  name: 'ActionSettingsItem',
  props: {
    setting: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copyHint: false
    }
  },
  methods: {
    copy(setting) {
      const route = process.env.NODE_ENV === 'development' ?
        window.location.host : `https://${window.location.host}/help/viewer`
      this.$copyText(`${route}?config=${setting}`)
        .then((e) => {
          this.copyHint = true
          setTimeout(() => {
            this.copyHint = false
          }, 3000)
        }, (e) => {
          alert(`Can't upload config`)
        })
    },
    removeSetting(setting) {
      this.$emit('changeStorageSettings', false)
      let settingsList = JSON.parse(this.$localStorage.get('settingsList'))
      const clearedSettingsList = settingsList.filter(e => e !== setting)
      this.$localStorage.set('settingsList', JSON.stringify(clearedSettingsList))
      setTimeout(() => {
        this.$emit('changeStorageSettings', true)
      }, 200)
    },
    settingTitle(value) {

      const config = value
        .replace('config-', '')
        .replace('.json', '')
      const millisecondsIndex = value
        .replace('config-', '')
        .replace('.json', '')
        .lastIndexOf('_')

      const milliseconds = config.substr(millisecondsIndex + 1)
      const clearedDate = config.substr(0, millisecondsIndex)
        .replace('__', ' ')
        .replace(/_/g, ':')
        .replace(/-/g, '/')

      const formattedDate = new Date(clearedDate)
      formattedDate.setMilliseconds(milliseconds)

      const options = {
        weekday: 'short', month: 'short', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        milliseconds: 'numeric'
      }
      return new Intl.DateTimeFormat('en-US',options).format(formattedDate)
    },
    getUrl(setting) {
      return process.env.NODE_ENV === 'development' ?
        `?config=${setting}` : `/help/viewer/?config=${setting}`
    },
  }
}
</script>
<style lang="scss" scoped>
.external {
  margin-right: 5px;
}
.setting-actions {
  white-space: nowrap;
}
.setting-title a {
  white-space: nowrap;
}
</style>
